<!-- 球队管理 -->
<template>
    <div>
        <event-head></event-head>
        <div class="bottom_btn">
            <el-button type="primary" class="addVenue" @click="addTeam">新增</el-button>
        </div>
        <div class="mt-3">
            <el-table :data="teamList" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="logo" label="球队logo" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.logo" style="width: 50px;height:50px"
                            @click="editLogo(scope.row)"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="teamName" label="球队名称" align="center"></el-table-column>
                <el-table-column prop="captainName" label="队长姓名" align="center"></el-table-column>
                <el-table-column prop="personNO" label="队长ID" align="center"></el-table-column>
                <el-table-column prop="signTime" label="报名时间" align="center"></el-table-column>
                <el-table-column prop="mobile" label="联系电话" align="center"></el-table-column>
                <el-table-column prop="teamGroupName" label="分组" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="retire(scope.row)">退赛</el-button>
                        <el-button type="text" @click="editGroup(scope.row)">编辑</el-button>
                        <el-button type="text" @click="setSort(scope.row)">设置排名</el-button>
                        <el-button type="text" @click="sellLeader(scope.row)">转让队长</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
        <el-dialog :visible.sync="dialogVisible" title="编辑球队信息">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="球队logo">
                    <f-image-upload v-model="form.logo" :width="'150px'" :height="'150px'"></f-image-upload>
                </el-form-item>
                <el-form-item label="球队名称">
                    <el-input v-model="form.teamName"></el-input>
                </el-form-item>
                <el-form-item label="队长姓名" prop="captainName">
                    <el-input v-model="form.captainName"></el-input>
                </el-form-item>
                <el-form-item label="队长足球行Id">
                    <el-input v-model="form.personNo"></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input v-model="form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="分组">
                    <el-select v-model="form.teamGroupName" placeholder="请选择组别" @change="groupChange">
                        <el-option v-for="item in groupData" :key="item.teamGroupId" :label="item.teamGroupName"
                            :value="item.teamGroupName">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveLogo">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="sortVisible" title="设置排序">
            <el-form ref="form" :model="sortForm" label-width="100px">
                <el-form-item label="排名">
                    <el-input type="number" v-model="sortForm.sort"></el-input>
                    <span style="color: red;">此处排名仅对积分相同的球员有效</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="sortVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveSort">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="addTeamVisible" title="新增球队" @close="closeTeam">
            <el-form ref="form" :model="adddForm" label-width="100px">
                <el-form-item label="球队logo">
                    <f-image-upload v-model="adddForm.logo" :width="'150px'" :height="'150px'"></f-image-upload>
                </el-form-item>
                <el-form-item label="球队名称">
                    <el-input v-model="adddForm.teamName"></el-input>
                </el-form-item>
                <el-form-item label="队长名称">
                    <el-input v-model="adddForm.teamLeader"></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input v-model="adddForm.mobile"></el-input>
                </el-form-item>
                <el-form-item label="队长足球行Id">
                    <el-input v-model="adddForm.personNo"></el-input>
                </el-form-item>
                <el-form-item label="分组">
                    <el-select v-model="adddForm.teamGroupName" placeholder="请选择组别" @change="groupAddChange">
                        <el-option v-for="item in groupData" :key="item.teamGroupId" :label="item.teamGroupName"
                            :value="item.teamGroupName">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addTeamVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveTeam">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="sellLeaderVisible" title="转让队长" @close="closesell" >
            <el-form ref="sellForm" :model="sellForm" label-width="100px" :rules="rule">
                <el-form-item label="用户编号" prop="personNo">
                    <el-input v-model="sellForm.personNo" onKeyUp="value=value.replace(/[\W]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="用户姓名" prop="captainName">
                    <el-input v-model="sellForm.captainName"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="sellLeaderVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveSellForm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
import FImageUpload from '@/common/components/Upload/f-image-upload';
export default {
    components: {
        FImageUpload, EventHead
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
            sortForm: {},
            dialogVisible: false,
            formData: {},
            teamList: [],
            Jersey: [{
                value: "红色",
                label: "红色"
            },
            {
                value: "橙色",
                label: "橙色"
            },
            {
                value: "黄色",
                label: "黄色"
            },
            {
                value: "绿色",
                label: "绿色"
            },
            {
                value: "蓝色",
                label: "蓝色"
            },
            {
                value: "黑色",
                label: "黑色"
            },
            {
                value: "紫色",
                label: "紫色"
            }],
            dropdownName: "万象足球杯联赛",
            matchList: [],
            matchInfo: {},
            teamGroupId: "",
            groupData: [],
            form: {},
            adddForm: {},
            sellForm:{},
            rule: {
                personNo: [{ required: true, message: '请输入', trigger: 'blur' }],
                captainName: [{ required: true, message: '请输入', trigger: 'change' }],
            },
            addTeamVisible: false,
            sortVisible: false,
            sellLeaderVisible:false
        };
    },
    mounted() {
        if (localStorage.getItem('matchId')) {
            this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
            this.getTeamList()
            this.getTeamGroupList()
        } else {
            this.$confirm('暂无赛事！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
        }
    },
    methods: {
        // 头部组件切换比赛，加载接口数据
        // changeMatch(match) {
        //     this.matchInfo = match;
        //     this.getTeamList(),
        //         this.getTeamGroupList()
        // },
        // 获取球队
        async getTeamList() {
            const params = {
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
            };
            const { res } = await this.$http.get(`/Match/TeamList/${this.matchInfo.matchId}`, { params });
            this.teamList = res.data.list || [];
            this.pageInfo.count = res.data.total;

        },
        // 分页
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.getTeamList();
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
            console.log(1111, val)
            this.getTeamList();
        },
        // 获取组别
        async getTeamGroupList() {
            const { res } = await this.$http.get(`/Match/TeamGroupList/${this.matchInfo.matchId}`);
            this.groupData = res.data || [];
        },
        // 选择组别
        groupChange(val) {
            this.form.teamGroupId = this.groupData.find(item => {
                return item.teamGroupName === val;
            }).teamGroupId;
        },
        // 修改球队信息
        editGroup(row) {
            this.dialogVisible = true
            this.form = row
        },
        // 新增球队信息
        addTeam() {
            this.addTeamVisible = true
        },
        // 选择球队
        groupAddChange(val) {
            this.adddForm.teamGroupId = this.groupData.find(item => {
                return item.teamGroupName === val;
            }).teamGroupId;
        },
        // 保存球队
        saveTeam() {
            this.adddForm.matchId = this.matchInfo.matchId
            this.$confirm('确定要添加该球队吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                const { res } = await this.$http.post('/Match/AddTeam', this.adddForm);
                if (res.isSuccess) {
                    this.$showSuccess('发布成功');
                    this.addTeamVisible = false
                    this.getTeamList();
                }
            });

        },
        // 关闭弹窗
        closeTeam() {
            this.addTeamVisible = false;
            this.adddForm = {}
        },
        // 编辑球队信息
        saveLogo() {
            this.$confirm('确定要修改该球队信息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                const { res } = await this.$http.post('/Match/UpdateTeamInfo', this.form);
                if (res.isSuccess) {
                    this.$showSuccess('发布成功');
                    this.dialogVisible = false
                    this.getTeamList();
                }
            });

        },
        // 删除球队
        retire(row) {
            this.$confirm('点击删除后，该球队信息将被清理，确认删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { res } = await this.$http.post(`/Match/DeleteTeam/${this.matchInfo.matchId}/${row.matchTeamId}`);
                if (res.isSuccess) {
                    this.$showSuccess('发布成功');
                    this.getTeamList();
                }
            });
        },
        // 排序弹窗
        setSort(row) {
            this.sortVisible = true
            this.matchTeamId = row.matchTeamId
        },
        // 保存排序
        saveSort() {
            this.sort = this.sortForm.sort
            this.$confirm('确定要设置该球队排名吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                const { res } = await this.$http.post(`/Match/SetSameScoreSort/${this.matchTeamId}/${this.sort}`);
                if (res.isSuccess) {
                    this.$showSuccess('发布成功');
                    this.sortVisible = false
                    this.getTeamList();
                }
            });

        },
        //转让队长弹窗
        sellLeader(row){
            this.sellLeaderVisible = true
            this.sellForm.matchTeamId = row.matchTeamId
        },
        // 确认转让队长
        saveSellForm(){
            this.$refs.sellForm.validate((valid) => {
                if (valid) {
                    this.$confirm('请核实信息，确定将队长转让给该用户吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(async () => {
                        const { res } = await this.$http.post('/Match/TransTeam', this.sellForm);
                        if (res.isSuccess) {
                            this.$showSuccess('转让成功');
                            this.sellLeaderVisible = false
                            this.getTeamList();
                        }
                    });
                } else {
                    this.$message.error("请填写完整信息！");
                    return
                }
            })
        },
        // 关闭弹窗
        closesell(){
            this.sellLeaderVisible = false
            this.sellForm={}
        }
    },
};
</script>

<style lang="scss" scoped>
.cardinal {
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;

}

/deep/.el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
    background-color: transparent;
    opacity: 1;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    color: #fff;
    border-radius: 0;
}

.bottom_btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;

    .addVenue {
        color: #fff;
    }
}
</style>